import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Popover } from '@sravni/react-design-system/lib/Popover';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useBoolean } from '@sravni/react-utils';

import { ContextMenuSvg } from '@src/components/icons/contextMenu';
import { Info } from '@src/components/icons/info';

import styles from './SponsoredMenu.module.scss';

export function SponsoredMenu({ company, token }: { company: string; token: string }) {
  const [visible, setVisible] = useBoolean(false);
  const [copied, setCopied] = useBoolean(false);

  const copy = () => navigator.clipboard.writeText(token).then(setCopied.on).catch(setCopied.off);

  return (
    <Popover
      className={styles.popoverContainer}
      visible={visible}
      onClose={() => {
        setVisible.off();
        setCopied.off();
      }}
      content={
        <Space direction="column" size={8}>
          <Text className={styles.text}>{company} </Text>
          <Button variant="text" color="blue" onClick={copy}>
            <Icon color="blue" icon={<Info />} />
            {/* пришлось стили накинуть иначе темный текст */}
            <Text className={styles.buttonText}>{copied ? 'Скопирован' : 'Скопировать токен'}</Text>
          </Button>
        </Space>
      }
    >
      <div className={styles.container}>
        <Icon icon={<ContextMenuSvg />} onClick={setVisible.on} />
      </div>
    </Popover>
  );
}
